import { useTranslation } from 'react-i18next'
import { TRange } from '../../../node.type'
import { getValidSortedRanges } from './range.helper'

interface RangeCoverageInfoProps {
  ranges: TRange[]
  minValue: number
  maxValue: number
}

export function RangeCoverageInfo({ ranges, minValue, maxValue }: RangeCoverageInfoProps) {
  const { t } = useTranslation()

  const getCoveredValues = (): string => {
    const sortedRanges = getValidSortedRanges(ranges)

    if (sortedRanges.length === 0)
      return t('pages.configuration.followups.chatbot.conditional-sections.no-range-defined')
    const gaps: string[] = []

    const firstRange = sortedRanges[0]
    if (firstRange && firstRange.lowerBound > minValue) {
      gaps.push(`${minValue}-${firstRange.lowerBound - 1}`)
    }

    for (let i = 0; i < sortedRanges.length - 1; i++) {
      const currentRange = sortedRanges[i]
      const nextRange = sortedRanges[i + 1]
      if (currentRange && nextRange && currentRange.upperBound + 1 < nextRange.lowerBound) {
        gaps.push(`${currentRange.upperBound + 1}-${nextRange.lowerBound - 1}`)
      }
    }

    const lastRange = sortedRanges[sortedRanges.length - 1]
    if (lastRange && lastRange.upperBound < maxValue) {
      gaps.push(`${lastRange.upperBound + 1}-${maxValue}`)
    }

    if (gaps.length === 0) {
      return t('pages.configuration.followups.chatbot.conditional-sections.all-values-covered')
    }

    return t('pages.configuration.followups.chatbot.conditional-sections.uncovered-values', {
      values: gaps.join(', '),
    })
  }

  return <div className="c-text-xs c-text-gray-600 c-px-3">{getCoveredValues()}</div>
}
